<template>
  <div class="member-detail-page">
    <div class="page-head">
      <GlobalInfoBar>订单详情</GlobalInfoBar>
      <el-button type="primary" size="small" @click="getMemberDetails">刷新</el-button>
    </div>

    <section class="status-card">
      <div class="info-item inline">
        <span class="label">订单状态</span>
        <span class="value status-value">{{ statusText }}</span>
      </div>
      <!-- <div v-if="infoDetails.status == 2" class="info-item inline cancel-reason">
        <span class="label">取消原因</span>
        <span class="value">{{ formatValue(infoDetails.cancel_var) }}</span>
      </div> -->
      <template v-if="infoDetails.status == 2">
        <div class="info-item inline">
          <span class="label">取消时间</span>
          <span class="value">{{ infoDetails.cancel_time }}</span>
        </div>
        <div class="info-item inline cancel-reason">
          <span class="label">取消原因</span>
          <span class="value">{{ formatValue(infoDetails.cancel_var) }}</span>
        </div>
      </template>
    </section>

    <section class="detail-card">
      <h3>订单信息</h3>
      <div class="detail-card-body">
      <div class="info-grid">
        <div v-for="item in orderInfoFields" :key="item.label" class="info-item">
          <span class="label">{{ item.label }}</span>
          <span class="value" v-if="item.type !== 'images'">{{ formatValue(item.value) }}</span>
          <div v-else class="image-list">
            <template v-if="getImageList(item.value).length">
              <el-image
                v-for="(url, index) in getImageList(item.value)"
                :key="`${url}_${index}`"
                :src="url"
                :preview-src-list="getImageList(item.value)"
                fit="cover"
                class="protocol-img"
              ></el-image>
            </template>
            <span v-else class="value">--</span>
          </div>
        </div>
      </div>
      </div>
    </section>

    <section class="detail-card">
      <div class="detail-card-title">
        <h3>顾客信息</h3>
        <el-button type="text" class="edit-link" @click="openCustomerEdit">编辑</el-button>
      </div>
      <div class="detail-card-body">
      <div class="info-grid">
        <div v-for="item in customerInfoFields" :key="item.label" class="info-item">
          <span class="label">{{ item.label }}</span>
          <span class="value">{{ formatValue(item.value) }}</span>
        </div>
      </div>
      </div>
    </section>

    <section class="detail-card">
      <h3>会员信息</h3>
      <div class="detail-card-body">
      <div class="info-grid">
        <div v-for="item in memberInfoFields" :key="item.label" class="info-item">
          <span class="label">{{ item.label }}</span>
          <span class="value">{{ item.money ? formatMoney(item.value) : formatValue(item.value) }}</span>
        </div>
      </div>
      </div>
    </section>

    <section class="detail-card">
      <h3>开通信息</h3>
      <div class="detail-card-body">
      <div class="info-grid">
        <div v-for="item in openInfoFields" :key="item.label" class="info-item">
          <span class="label">{{ item.label }}</span>
          <span class="value">{{ formatValue(item.value) }}</span>
        </div>
      </div>
      </div>
    </section>

    <section class="detail-card">
      <h3>权益信息</h3>
      <div class="detail-card-body">
      <el-table :data="interestsList" style="width: 100%">
        <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
        <el-table-column prop="interest_name" label="权益名称" width="300">
          <template slot-scope="{ row }">{{ formatValue(row.interest_name) }}</template>
        </el-table-column>
        <el-table-column prop="interest_content" label="权益内容">
          <template slot-scope="{ row }">{{ formatValue(row.interest_content) }}</template>
        </el-table-column>
      </el-table>
      </div>
    </section>

    <section class="detail-card">
      <h3>赠品信息</h3>
      <div class="detail-card-body">
      <el-table :data="goodsList" style="width: 100%">
        <el-table-column type="index" label="序号" width="70" align="center"></el-table-column>
        <el-table-column prop="goods_name" label="产品">
          <template slot-scope="{ row }">{{ formatValue(row.goods_name) }}</template>
        </el-table-column>
        <el-table-column prop="goods_price" label="零售价">
          <template slot-scope="{ row }">{{ formatMoney(row.goods_price) }}</template>
        </el-table-column>
        <el-table-column prop="goods_num" label="数量">
          <template slot-scope="{ row }">x{{ formatValue(row.goods_num) }}</template>
        </el-table-column>
      </el-table>
      </div>
    </section>

    <section class="detail-card">
      <h3>操作记录</h3>
      <div class="detail-card-body">
      <el-table :data="operateList" style="width: 100%">
        <el-table-column prop="created_at" label="操作时间" width="180">
          <template slot-scope="{ row }">{{ formatValue(row.created_at || row.add_time || row.operate_time) }}</template>
        </el-table-column>
        <el-table-column prop="operator_name" label="操作人姓名" width="160">
          <template slot-scope="{ row }">{{ formatValue(row.operator_name || row.staff_name || row.name) }}</template>
        </el-table-column>
        <el-table-column prop="operator_phone" label="操作人手机" width="170">
          <template slot-scope="{ row }">{{ formatValue(row.operator_phone || row.staff_phone || row.phone) }}</template>
        </el-table-column>
        <el-table-column prop="operator_passport" label="操作账号" width="170">
          <template slot-scope="{ row }">{{ formatValue(row.operator_passport || row.account || row.user_name || row.passport) }}</template>
        </el-table-column>
        <el-table-column prop="operator_type_text" label="操作项" width="160">
          <template slot-scope="{ row }">{{ formatValue(row.operator_type_text || row.operate_type || row.title) }}</template>
        </el-table-column>
        <el-table-column prop="content" label="操作内容">
          <template slot-scope="{ row }">
            <div v-if="formatOperationContent(row).length" class="operation-content-list">
              <div v-for="(item, index) in formatOperationContent(row)" :key="index" class="operation-content-item">
                <span class="operation-content-key">{{ item.key }}</span>
                <span>{{ item.value }}</span>
              </div>
            </div>
            <span v-else>{{ formatValue(row.operate_content || row.remark) }}</span>
          </template>
        </el-table-column>
      </el-table>
      </div>
    </section>

    <el-dialog
      title="编辑"
      :visible.sync="customerDialogVisible"
      width="338px"
      custom-class="customer-edit-dialog"
      :close-on-click-modal="true"
      @closed="resetCustomerForm"
    >
      <el-form
        ref="customerForm"
        :model="customerForm"
        :rules="customerRules"
        label-position="top"
        class="customer-form"
      >
        <el-form-item label="顾客姓名" prop="name">
          <el-input v-model.trim="customerForm.name" maxlength="10">
            <span slot="suffix" class="input-count">{{ customerForm.name.length }}/10</span>
          </el-input>
        </el-form-item>
        <el-form-item label="顾客手机号" prop="phone">
          <el-input v-model.trim="customerForm.phone" maxlength="11">
            <span slot="suffix" class="input-count">{{ customerForm.phone.length }}</span>
          </el-input>
        </el-form-item>
        <el-form-item label="顾客身份证" prop="identity">
          <el-input v-model.trim="customerForm.identity" maxlength="18">
            <span slot="suffix" class="input-count">{{ customerForm.identity.length }}</span>
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="customerDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="customerSaving" @click="saveCustomerInfo">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  userCardEdit,
  userCardInfo
} from "@/utils/request/membershipSystem";

export default {
  name: "memberDetails",
  data() {
    return {
      infoDetails: {},
      customerDialogVisible: false,
      customerSaving: false,
      customerForm: {
        name: "",
        phone: "",
        identity: "",
      },
      customerRules: {
        name: [
          { required: true, message: "请输入顾客姓名", trigger: "blur" },
          { min: 1, max: 10, message: "顾客姓名需为1-10个字符", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入顾客手机号", trigger: "blur" },
          { pattern: /^\d{11}$/, message: "顾客手机号需为11位数字", trigger: "blur" },
        ],
        identity: [
          { pattern: /^$|^\d{17}[\dXx]$/, message: "顾客身份证需为18位", trigger: "blur" },
        ],
      },
    };
  },
  computed: {
    statusText() {
      const map = {
        0: "待核销",
        1: "已核销",
        2: "已取消",
      };
      return map[this.infoDetails.status] || "--";
    },
    orderInfoFields() {
      return [
        { label: "会员卡号", value: this.infoDetails.card_number },
        { label: "购机串号", value: this.infoDetails.imei },
        { label: "注册服务", value: this.infoDetails.is_order || this.infoDetails.register_service || '无' },
        { label: "下单时间", value: this.infoDetails.add_time },
        { label: "协议照片", value: this.infoDetails.protocol_img, type: "images" },
        { label: "订单备注", value: this.infoDetails.notes },
      ];
    },
    customerInfoFields() {
      return [
        { label: "顾客姓名", value: this.infoDetails.name },
        { label: "顾客手机号", value: this.infoDetails.phone },
        { label: "顾客身份证", value: this.infoDetails.identity },
      ];
    },
    memberInfoFields() {
      return [
        { label: "会员名称", value: this.infoDetails.plan_title },
        { label: "售价", value: this.infoDetails.amount, money: true },
        { label: "卡面储值", value: this.infoDetails.parvalue, money: true },
        { label: "当前剩余", value: this.infoDetails.balance, money: true },
        // { label: "成本总价", value: this.infoDetails.total_cost, money: true },
        // { label: "毛利", value: this.infoDetails.profit, money: true },
      ];
    },
    openInfoFields() {
      return [
        { label: "开通门店", value: this.infoDetails.shop_name },
        { label: "开通大区", value: this.infoDetails.area_name || this.infoDetails.area_title },
        { label: "开通商户", value: this.infoDetails.store_name },
        { label: "开通人姓名", value: this.infoDetails.staff_name },
        { label: "开通人手机", value: this.infoDetails.staff_phone },
      ];
    },
    interestsList() {
      return Array.isArray(this.infoDetails.plan_interests) ? this.infoDetails.plan_interests : [];
    },
    goodsList() {
      return Array.isArray(this.infoDetails.plan_goods) ? this.infoDetails.plan_goods : [];
    },
    operateList() {
      const list = this.infoDetails.operation_log || this.infoDetails.operate_list || this.infoDetails.operation_list || this.infoDetails.log_list || this.infoDetails.logs;
      return Array.isArray(list) ? list : [];
    },
  },
  mounted() {
    this.getMemberDetails();
  },
  methods: {
    getMemberDetails() {
      const { card_id } = this.$route.query;
      userCardInfo({ card_id }).then((res) => {
        this.infoDetails = res.data || {};
      });
    },
    formatValue(value) {
      if (value === "" || value === undefined || value === null) return "--";
      return value;
    },
    formatMoney(value) {
      if (value === "" || value === undefined || value === null) return "--";
      const numberValue = Number(value);
      if (Number.isNaN(numberValue)) return value;
      return `¥${numberValue.toLocaleString("zh-CN", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })}`;
    },
    getImageList(value) {
      if (!value) return [];
      if (Array.isArray(value)) return value.filter(Boolean);
      return [value];
    },
    formatOperationContent(row) {
      if (!Array.isArray(row.content)) {
        return [];
      }
      return row.content
        .filter(item => item && (item.key || item.value))
        .map(item => ({
          key: item.key || '',
          value: this.formatValue(item.value),
        }));
    },
    openCustomerEdit() {
      this.customerForm = {
        name: this.infoDetails.name ? String(this.infoDetails.name) : "",
        phone: this.infoDetails.phone ? String(this.infoDetails.phone) : "",
        identity: this.infoDetails.identity ? String(this.infoDetails.identity) : "",
      };
      this.customerDialogVisible = true;
      this.$nextTick(() => {
        if (this.$refs.customerForm) {
          this.$refs.customerForm.clearValidate();
        }
      });
    },
    resetCustomerForm() {
      if (this.$refs.customerForm) {
        this.$refs.customerForm.resetFields();
      }
    },
    saveCustomerInfo() {
      this.$refs.customerForm.validate((valid) => {
        if (!valid) return;
        const { card_id } = this.$route.query;
        this.customerSaving = true;
        userCardEdit({
          card_id,
          name: this.customerForm.name,
          phone: this.customerForm.phone,
          identity: this.customerForm.identity,
        }).then((res) => {
          this.$message.success(res.msg || "保存成功");
          this.customerDialogVisible = false;
          this.getMemberDetails();
        }).finally(() => {
          this.customerSaving = false;
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
.member-detail-page {
  padding: 0 20px 28px;
  background: #f2f2f2;
  min-height: 100vh;
}

.page-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  margin-bottom: 18px;
  padding-right: 10px;
}

.status-card,
.detail-card {
  background: #fff;
  margin-bottom: 18px;
  border-radius: 8px;
  // box-shadow: 0 1px 6px rgba(0, 0, 0, 0.2);
}

.status-card {
  display: flex;
  align-items: center;
  min-height: 52px;
  padding: 0 34px;
}

.detail-card {
  padding: 18px 22px 22px;

  h3 {
    margin: 0 0 22px;
    font-size: 15px;
    font-weight: 600;
    color: #111;
  }
}

.detail-card-title {
  display: flex;
  align-items: center;
  margin-bottom: 22px;

  h3 {
    margin: 0;
  }
}

.edit-link {
  padding: 0;
  margin-left: 14px;
}

.detail-card-body {
  padding: 0;
}

.info-grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  row-gap: 22px;
  column-gap: 48px;
}

.info-item {
  display: flex;
  align-items: flex-start;
  min-height: 22px;
  font-size: 14px;

  .label {
    flex: 0 0 92px;
    color: #999;
    text-align: right;
    margin-right: 20px;
  }

  .value {
    flex: 1;
    color: #111;
    word-break: break-all;
    line-height: 20px;
  }
}

.info-item.inline {
  min-height: 0;
  margin-right: 46px;

  .label {
    flex: none;
  }
}

.status-value {
  font-weight: 600;
}

.cancel-reason {
  flex: 1;
}

.image-list {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.protocol-img {
  width: 65px;
  height: 65px;
  // border: 3px solid #cfcfcf;
  background: #f5f5f5;
}

.operation-content-list {
  line-height: 22px;
}

.operation-content-item {
  display: flex;
  align-items: flex-start;
}

.operation-content-key {
  flex: 0 0 auto;
  margin-right: 4px;
  color: #666;
}

::v-deep .customer-edit-dialog {
  .el-dialog__header {
    padding: 20px 20px 14px;
    border-bottom: 1px solid #e5e5e5;
  }

  .el-dialog__title {
    font-size: 14px;
    font-weight: 600;
    color: #111;
  }

  .el-dialog__body {
    padding: 18px 20px 20px;
  }

  .el-dialog__footer {
    padding: 18px 16px 20px;
    border-top: 1px solid #f0f0f0;
  }
}

.customer-form {
  .el-form-item {
    margin-bottom: 16px;
  }

  ::v-deep .el-form-item__label {
    padding: 0 0 6px;
    line-height: 18px;
  }

  ::v-deep .el-input__inner {
    border-radius: 0;
    padding-right: 52px;
  }
}

.input-count {
  color: #f56c6c;
  font-size: 12px;
}
</style>
